import React from "react";
import "./Avatar.css";

const Avatar = () => {
  return (
    <img src="http://i.pravatar.cc/30" alt="post-avatar" className="avatar" />
  );
};

export default Avatar;
